import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class FidelityIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getFidelityIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.FIDELITY_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    activateFidelityIntegration(postParams) {
        const url = this.urlsService.INTEGRATIONS.FIDELITY_ACTIVATE;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    deactivateFidelityIntegration() {
        const url = this.urlsService.INTEGRATIONS.FIDELITY_DEACTIVATE;
        return this.ajaxService.postJsonDataObserveBody(url, {});
    }
    getFidelityAccountSearchResults(searchTerms, page, sortColumn, sortDirection) {
        let url = `${this.urlsService.INTEGRATIONS.FIDELITY_ACCOUNT_SEARCH}?searchTerms=${encodeURIComponent(searchTerms)}&page=${page}`;
        if (sortColumn) {
            url += `&sortColumn=${encodeURIComponent(sortColumn)}&sortDirection=${sortDirection || 'asc'}`;
        }
        return this.ajaxService.getDataObserveBody(url);
    }
    importFidelityHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.FIDELITY_IMPORT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
FidelityIntegrationService.ɵfac = function FidelityIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FidelityIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
FidelityIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FidelityIntegrationService, factory: FidelityIntegrationService.ɵfac, providedIn: 'root' });
